












































































import VueOptions from '@utils/VueOptions'

path = 'https://autocomplete.clearbit.com/v1/companies/suggest'

settings =
  name: 'LogoSelector'

  vue:
    props: [
      'initialSelectedLogo',
      'placeholder',
      'alwaysOptions',
      'guess',
      'searchModeLabel',
      'guessModeLabel',
      'changeItLabel',
      'actions',
      'errors',
      'options',
    ]

    data: ->
      search: ''

      selectedLogo: null
      userSelectedLogo: false
      searchMode: true

      editLogoName: false
      editLogoDomain: false

    mounted: ->
      if @initialSelectedLogo?.name || @initialSelectedLogo?.domain
        @selectedLogo = @initialSelectedLogo 
      else
        @changeIt()

      if @guess
        @clearEditMode()
        @autoGuess()

    computed:
      placeholderText: -> @placeholder || 'Organization name'

      otherLogo: ->
        {
          name: null,
          domain: null,
          logo: null
        }

      hasDomainSelected: -> !!@selectedLogo.domain?.length

      disableChangeIt: -> @options?.disableChangeIt

    methods:
      hiChangeIt: ->
        @changeIt()
        @editLogoDomain = true

      hiSearch: (text, cb) ->
        results = await @searchLogos(text)
        cb(results)

      hiSelect: (item) ->
        @userSelectedLogo = true
        @selectedLogo = item
        @actions?.hiSelect item
        @clearEditMode()

      changeIt: ->
        @selectedLogo = @otherLogo
        @actions.hiSelect @selectedLogo

      clearEditMode: ->
        @editLogoName = false
        @editLogoDomain = false

      cleanup: ->
        @selectedLogo = @otherLogo
        @actions.hiSelect @selectedLogo
        @clearEditMode()

      searchLogos: (text) ->
        return [...(@alwaysOptions || [])] if !text || !"#{text}".length
        response = await fetch("#{path}?query=#{text}")
        results = await response.json()
        results ||= []

        # filter results to remove any duplicates from AlwaysOptions
        results = [...@alwaysOptions, ...results] if @alwaysOptions
        results

      autoGuess: ->
        results = await @searchLogos @guess

        unless @selectedLogo?.name
          @selectedLogo = results.find((c) => c?.domain?.includes @guess)

          @selectedLogo ||=
            name: @nameFromURL(@guess)
            domain: @guess
            logo: null

          @actions.hiSelect @selectedLogo

      nameFromURL: (url) ->
        name = url.replace(/(https?:\/\/)?(www.)?/i, '').split('.')[0]
        @format('title', name)

    watch:
      errors: ->
        @editLogoName = true if @errors.name

export default VueOptions.vue settings
